import React, { useState, useEffect } from 'react';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Table from '@mui/material/Table';
import { TableCell, styled } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

const fetchMeetingRooms = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/meetingRooms`);
    return response.data;
};

const fetchBookings = async (date) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/BookingDate/${date}`);
    return response.data;
};
  
export default function Calendar(){
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    '&:hover': {
      backgroundColor: 'rgba(255, 83, 46, 1) !important',
    },
    // Add your other styles here
  }));
    const navigate = useNavigate();
    const [booked, setBooked] = useState(null);
    const [tanggalBooking, setTanggalBooking] = useState(new Date())
    const [openCancellation, setOpenCancellation] = useState(false);
    const [toCancel, setToCancel] = useState();
    const times = Array.from({length: 48}, (_, i) => {
        const hour = Math.floor(i/2);
        const minute = i%2 === 0 ? '00' : '30';
        const nextHour = Math.floor((i+1)/2);
        const nextMinute = (i+1)%2 === 0 ? '00' : '30';
        return `${hour.toString().padStart(2, '0')}:${minute}-${nextHour.toString().padStart(2, '0')}:${nextMinute}`;
    });
    
    const [rooms, setRooms] = useState([]);
    useEffect(() => {
        const date = new Date();
        const formattedDate = date.toISOString().split('T')[0];

        fetchMeetingRooms().then(res => {
            if (res) {
                let roomss = res.flatMap(address => {
                    return (address.RuangMeeting || []).map(room => ({
                        ...room,
                        location: address.LokasiSingkatan
                    }));
                });
                setRooms(roomss);
            } else {
                console.error('Response is undefined: ', res);
            }
        }).catch(err => console.error('An error occurred while fetching meeting rooms: ', err));
          
    
        fetchBookings(formattedDate).then(bookings => {
            const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
            setBooked(bookedCells);
        });
    }, []);

    const changeTanggalBooking = (event) => {
        setTanggalBooking(event)
        const date = new Date(event);
        const formattedDate = date.toISOString().split('T')[0];
        fetchBookings(formattedDate).then(bookings => {
            const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
            setBooked(bookedCells);
        });
    }

    const styles = {
      root: {
        display: 'flex',
        overflow: 'auto',
      },
      tableWrapper: {
        width: 'calc(120% - 150px)', // Adjust as needed
        overflowX: 'auto',
      },
      stickyCell: {
        position: 'sticky',
      left: '0px',
      width: '150px', // Adjust this to change the width of the first sticky column
      backgroundColor: '#fff', // Ensure that the sticky cells have a background to avoid content overlapping
      border: '1px solid black',
      },
      subheadingCell: {
          backgroundColor: '#fad784',
          fontWeight: 'bold',
          textAlign: 'center',
        },
        cell: {
          border: '1px solid black', // This will give a black border to the cells
        },
    }

    let locationSubHeadingIndex = -1;

    const moveToNewBooking = () => {
        navigate("/NewBooking");
    }

    const cancelInitiation = (bookingData) => {
        setToCancel(bookingData)
        setOpenCancellation(true);
    }

    const cancelConfirmation = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/cancelBookingItem`, { id: toCancel.id });
            window.location.reload();
        } catch (error)        {
          console.error('An error occurred while canceling the booking item.', error);
      }
  }

  return (
    <>
    {/* Below is the Calendar Module */}
    <Grid container xs={12} style={{ transform: 'scale(0.8)',  transformOrigin: 'top left' }}>
          <Grid  xs={14} sx={{mt:2}}>
              <Grid>
                  <div>
                      <div>
                      <TableContainer component={Paper} style={{maxHeight: '65vh', overflow: 'auto', border: '0.3px solid black',   // Thick Border
      boxShadow: '5px 5px 7px grey'}}>

                                                                          <Table stickyHeader>
                                  <TableHead>
                                      <TableRow>
                                          <TableCell>Room Name</TableCell>
                                          {times.map((time, index) => (
                                              <TableCell key={index} style={{...styles.cell}}>{time}</TableCell>
                                          ))}
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {rooms.flatMap((room, roomIndex) => {
                                          const elements = [];
                                          if (room.location !== rooms[locationSubHeadingIndex]?.location) {
                                              elements.push(
                                                  <TableRow key={'loc_' + room.location}>
                                                      <TableCell style={{...styles.cell,...styles.stickyCell,...styles.subheadingCell}}>{room.location}</TableCell>
                                                      <TableCell style={{...styles.cell,...styles.subheadingCell}} colSpan={times.length} />
                                                  </TableRow>
                                              );
                                              locationSubHeadingIndex = roomIndex;
                                          }
                                          elements.push(
                                              <TableRow key={roomIndex}>
                                              <TableCell style={{...styles.cell,...styles.stickyCell}}>{room.name}</TableCell>
                                                  {times.map((time, timeIndex) => {
                                                      const bookingData = booked?.find(
                                                          booking => booking.code === room.code && booking.timeIndex === timeIndex + 1
                                                      );
                                                      const isBooked = !!bookingData;
                                                      return (
                                                          <Tooltip
                                                              title={
                                                                  isBooked 
                                                                  ? (
                                                                      <React.Fragment>
                                                                          <div>
                                                                              Client Name: {bookingData?.userData?.client?.Name || 'no data'}
                                                                          </div>
                                                                          <div>
                                                                              Company Name: {bookingData?.userData?.company?.companyName || 'no data'}
                                                                          </div>
                                                                      </React.Fragment>
                                                                  )
                                                                  : ''
                                                              }
                                                              key={timeIndex}
                                                          >
                                                              <StyledTableCell
                                                                style={{
                                                                  ...styles.cell,
                                                                  backgroundColor: isBooked ? 'red' : 'white',
                                                                }}
                                                              />
                                                          </Tooltip>
                                                      );
                                                  })}
                                              </TableRow>
                                          );
                                          return elements;
                                      })}
                                  </TableBody>
                              </Table>
                          </TableContainer>
                      </div>
                  </div>
              </Grid>
          </Grid>
      </Grid>
      </>
  );
};

